var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m408 80c-40 0-51.945312 28.566406-64 40-12.054688-11.433594-24-40-64-40-37.128906 0-56 42.871094-56 80 0 64 120 136 120 136s120-72 120-136c0-37.128906-18.871094-80-56-80zm0 0",
    fill: "#dd3e46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m184 0c-40 0-51.945312 28.566406-64 40-12.054688-11.433594-24-40-64-40-37.128906 0-56 42.871094-56 80 0 64 120 136 120 136s120-72 120-136c0-37.128906-18.871094-80-56-80zm0 0",
    fill: "#f98c96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m296 248c-40 0-51.945312 28.566406-64 40-12.054688-11.433594-24-40-64-40-37.128906 0-56 42.871094-56 80 0 64 120 136 120 136s120-72 120-136c0-37.128906-18.871094-80-56-80zm0 0",
    fill: "#f98c96"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.441406 174.65625-8.882812-13.3125c.679687-.457031 68.441406-46.207031 68.441406-89.34375h16c0 51.6875-72.480469 100.601562-75.558594 102.65625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 48h-16c.207031-2.195312-.582031-4.367188-2.152344-5.917969-1.570312-1.550781-3.75-2.316406-5.945312-2.082031l.097656-16c6.421875-.1875 12.636719 2.28125 17.175781 6.824219 4.542969 4.539062 7.011719 10.753906 6.824219 17.175781zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.441406 254.65625-8.882812-13.3125c.679687-.457031 68.441406-46.207031 68.441406-89.34375h16c0 51.6875-72.480469 100.601562-75.558594 102.65625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 128h-16c.207031-2.195312-.582031-4.367188-2.152344-5.917969-1.570312-1.550781-3.75-2.316406-5.945312-2.082031l.097656-16c6.421875-.1875 12.636719 2.28125 17.175781 6.824219 4.542969 4.539062 7.011719 10.753906 6.824219 17.175781zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.441406 422.65625-8.882812-13.3125c.679687-.457031 68.441406-46.207031 68.441406-89.34375h16c0 51.6875-72.480469 100.601562-75.558594 102.65625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 296h-16c.207031-2.195312-.582031-4.367188-2.152344-5.917969-1.570312-1.550781-3.75-2.316406-5.945312-2.082031l.097656-16c6.421875-.1875 12.636719 2.28125 17.175781 6.824219 4.542969 4.539062 7.011719 10.753906 6.824219 17.175781zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.496cb15feac38807cab0c5b857d338ce.svg";
export { ForwardRef as ReactComponent };